import { render } from "./Research.vue?vue&type=template&id=6b377e52&ts=true"
import script from "./Research.vue?vue&type=script&lang=ts"
export * from "./Research.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__